import { LegalPage, LegalSection } from "@/pages/legal/LegalPage";

export default function CGV() {
  return (
    <LegalPage
      testId="page-cgv"
      title="Conditions Générales de Vente (Partenaires)"
      updated="Juillet 2025"
      seoDescription="Conditions Générales de Vente applicables aux auto-écoles partenaires de PlanPermis."
    >
      <p>
        Les présentes Conditions Générales de Vente (« CGV ») régissent la relation entre PlanPermis et les
        auto-écoles partenaires (« Partenaires ») dans le cadre du service d'apport d'affaires.
      </p>

      <LegalSection title="1. Objet">
        <p>
          PlanPermis transmet aux Partenaires des demandes d'Élèves (« Leads ») correspondant à leurs zones
          d'intervention, en vue d'une éventuelle inscription à une formation.
        </p>
      </LegalSection>

      <LegalSection title="2. Commission fixée par le Partenaire">
        <p>
          Le Partenaire fixe librement, depuis son espace, le montant de la commission qu'il verse à PlanPermis pour
          chaque <strong>inscription confirmée</strong>. Ce montant peut être modifié à tout moment ; le montant
          applicable est celui en vigueur au jour de l'attribution du Lead.
        </p>
      </LegalSection>

      <LegalSection title="3. Fait générateur et facturation">
        <p>
          La commission est due lorsqu'un Élève transmis s'inscrit effectivement à une formation auprès du Partenaire.
          PlanPermis établit une facture correspondant aux commissions dues. Le Partenaire s'engage à déclarer
          loyalement les inscriptions issues des Leads transmis.
        </p>
        <p>
          La commission se calcule sur le <strong>montant réellement signé avec l'Élève</strong>. Si le Partenaire
          accorde à l'Élève une remise, un rabais ou un tarif plus avantageux que le tarif affiché, la commission
          reste due et est calculée sur le montant effectivement convenu au contrat de formation signé avec l'Élève.
          Le Partenaire s'engage à déclarer ce montant exact, sans minoration.
        </p>
      </LegalSection>

      <LegalSection title="4. Attribution et exclusivité">
        <p>
          Les Leads sont attribués par PlanPermis. Un Lead attribué l'est en exclusivité au Partenaire désigné. En
          l'absence d'aboutissement, PlanPermis peut réattribuer le Lead à un autre Partenaire.
        </p>
      </LegalSection>

      <LegalSection title="5. Obligations du Partenaire">
        <p>
          Le Partenaire s'engage à disposer des autorisations d'exercer requises, à répondre rapidement aux Élèves
          transmis qui le contactent et à fournir une prestation conforme à la réglementation applicable.
        </p>
      </LegalSection>

      <LegalSection title="6. Durée et résiliation">
        <p>
          Le partenariat est conclu pour une durée indéterminée et peut être résilié par l'une ou l'autre des parties,
          les commissions dues au titre des inscriptions antérieures restant exigibles.
        </p>
      </LegalSection>

      <LegalSection title="7. Données personnelles">
        <p>
          Le Partenaire s'engage à traiter les données des Élèves transmises dans le respect du RGPD, uniquement aux
          fins de la mise en relation, et à ne pas les utiliser à d'autres fins sans consentement.
        </p>
      </LegalSection>

      <LegalSection title="8. Droit applicable">
        <p>Les présentes CGV sont soumises au droit français.</p>
      </LegalSection>
    </LegalPage>
  );
}
